import PropTypes from 'prop-types';
import { NavbarLink } from 'platfi-ui-components';
import OnClickAnalyticEvent from 'components/OnClickAnalyticEvent';

const MainLink = ({ to, shouldRender = true, analyticEvent, ...rest }) => {
  if (!shouldRender) {
    return null;
  }

  const navLinkProps = { to, ...rest };

  if (analyticEvent) {
    return (
      <OnClickAnalyticEvent
        eventCategory={analyticEvent}
        eventOptions={{
          joinCategory: false,
        }}
      >
        <NavbarLink {...navLinkProps} />
      </OnClickAnalyticEvent>
    );
  }

  return <NavbarLink {...navLinkProps} />;
};

MainLink.propTypes = {
  to: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool,
  analyticEvent: PropTypes.string,
};

export default MainLink;
